import type { PostingDimensions } from '@festina/life-general-types/life'
import { listUtils } from '@festina-life/core'

type Dimensions = Extract<keyof PostingDimensions, `dim${string}`>
type Keys = Extract<keyof PostingDimensions, `key${string}`>
type DimensionsAndKeys = Dimensions | Keys

export const POSTING_DIMENSIONS = listUtils.arrayOfAllUnique<Dimensions>()([
  'dim1',
  'dim2',
  'dim3',
  'dim4',
  'dim5',
  'dim6',
  'dim7',
  'dim8',
])

export const POSTING_KEYS = listUtils.arrayOfAllUnique<Keys>()([
  'key1',
  'key2',
  'key3',
  'key4',
])

export const POSTING_DIMENSIONS_AND_KEYS =
  listUtils.arrayOfAllUnique<DimensionsAndKeys>()([
    ...POSTING_DIMENSIONS,
    ...POSTING_KEYS,
  ])
